import { render, staticRenderFns } from "./TableVehicles.vue?vue&type=template&id=b1316b50"
import script from "./TableVehicles.vue?vue&type=script&lang=js"
export * from "./TableVehicles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports